import { ActionCreator, Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IKlantGroepSelectie } from 'shared/models/IKlantGroepSelectie'
import { IApplicationState } from '../store'
import GlnService from 'shared/service/GlnService'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { IResponseAction } from '../interfaces'

export enum Actions {
  GetKlantGroepRequest = 'GetKlantGroepRequest',
  GetKlantGroepResponse = 'GetKlantGroepResponse',
  PostKlantGroepRequest = 'PostKlantGroepRequest',
  PostKlantGroepResponse = 'PostKlantGroepResponse',
  DeleteKlantGroepRequest = 'DeleteKlantGroepRequest',
  DeleteKlantGroepResponse = 'DeleteKlantGroepResponse',
}

export interface IGetKlantGroepRequestAction
  extends Action<Actions.GetKlantGroepRequest> {
  payload: IKlantGroepSelectie
}
export interface IGetKlantGroepResponseAction
  extends IResponseAction<Actions.GetKlantGroepResponse> {
  payload: IKlantGroepModel[]
}
export interface IPostKlantGroepRequestAction
  extends Action<Actions.PostKlantGroepRequest> {
  payload: IKlantGroepModel
}
export interface IPostKlantGroepResponseAction
  extends IResponseAction<Actions.PostKlantGroepResponse> {
  payload: string
}
export interface IDeleteKlantGroepRequestAction
  extends Action<Actions.DeleteKlantGroepRequest> {
  payload: IKlantGroepModel
}
export interface IDeleteKlantGroepResponseAction
  extends IResponseAction<Actions.DeleteKlantGroepResponse> {
  payload: string
}

export type KlantGroepActions =
  | IGetKlantGroepRequestAction
  | IGetKlantGroepResponseAction
  | IPostKlantGroepRequestAction
  | IPostKlantGroepResponseAction
  | IDeleteKlantGroepRequestAction
  | IDeleteKlantGroepResponseAction

export const postKlantgroepActionCreator: ActionCreator<
  ThunkAction<
    Promise<IPostKlantGroepResponseAction>,
    IApplicationState,
    null,
    IPostKlantGroepResponseAction
  >
> = (klantGroep: IKlantGroepModel) => {
  return async (dispatch: Dispatch) => {
    const postDataAction: IPostKlantGroepRequestAction = {
      type: Actions.PostKlantGroepRequest,
      payload: klantGroep,
    }
    dispatch(postDataAction)
    try {
      const result = await GlnService.postKlantgroep(klantGroep)
      const response: IPostKlantGroepResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.PostKlantGroepResponse,
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IPostKlantGroepResponseAction = {
        success: false,
        errorMessage: `fout bij opslaan groep: ${e.message}`,
        payload: null,
        type: Actions.PostKlantGroepResponse,
      }

      return dispatch(errorResponse)
    }
  }
}

export const deleteKlantgroepActionCreator: ActionCreator<
  ThunkAction<
    Promise<IDeleteKlantGroepResponseAction>,
    IApplicationState,
    null,
    IDeleteKlantGroepResponseAction
  >
> = (klantGroep: IKlantGroepModel) => {
  return async (dispatch: Dispatch) => {
    const postDataAction: IDeleteKlantGroepRequestAction = {
      type: Actions.DeleteKlantGroepRequest,
      payload: klantGroep,
    }
    dispatch(postDataAction)
    try {
      const result = await GlnService.verwijderKlantgroep(klantGroep)
      const reponse: IDeleteKlantGroepResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.DeleteKlantGroepResponse,
      }

      return dispatch(reponse)
    } catch (e) {
      const errorReponse: IDeleteKlantGroepResponseAction = {
        success: false,
        errorMessage: `fout bij verwijderen groep: ${e.message}`,
        payload: null,
        type: Actions.DeleteKlantGroepResponse,
      }

      return dispatch(errorReponse)
    }
  }
}

export const getKlantgroepenActionCreator: ActionCreator<
  ThunkAction<
    Promise<IGetKlantGroepResponseAction>,
    IApplicationState,
    null,
    IGetKlantGroepResponseAction
  >
> = (selectie: IKlantGroepSelectie) => {
  return async (dispatch: Dispatch) => {
    const requestDataAction: IGetKlantGroepRequestAction = {
      type: Actions.GetKlantGroepRequest,
      payload: selectie,
    }
    dispatch(requestDataAction)

    try {
      const result = await GlnService.getKlantgroepen(
        selectie.vestiging > 0 ? selectie.vestiging : undefined,
        selectie.code
      )
      const response: IGetKlantGroepResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetKlantGroepResponse,
      }

      if (
        (!result.success && result.errorCode === 404) ||
        (result.success && result.payLoad.length === 0)
      ) {
        response.success = false
        response.errorMessage = 'Geen tijdvakken gevonden'
      }

      return dispatch(response)
    } catch (e) {
      const errorReponse: IGetKlantGroepResponseAction = {
        success: false,
        errorMessage: `fout bij ophalen groepen: ${e.message}`,
        payload: null,
        type: Actions.GetKlantGroepResponse,
      }

      return dispatch(errorReponse)
    }
  }
}
